import { FC, HTMLAttributes, memo } from 'react';
import cls from 'classnames';
import { logger } from '@cutwise/utils';

import { IconName, iconNames } from './iconName';
import { ICONS } from './iconsMap';

// To add Icon, add svg to src/assets/icons, its name to ./iconName.ts and its import to ./iconsMap.ts
interface IconProps extends HTMLAttributes<HTMLSpanElement> {
  name: IconName;
  className?: string;
}

export const ICONS_MAP: Map<IconName, FC<Any>> = new Map(iconNames.map((name) => [name, ICONS[name]]));

function Icon(props: IconProps) {
  const { className, name, ...rest } = props;

  const IconComponent = ICONS_MAP.get(name);

  if (!IconComponent) {
    logger.error(`Icon with name ${name} not found`);

    return null;
  }

  return <IconComponent className={cls('cw-icon', className)} aria-label={`${name} icon`} {...rest} />;
}

export default memo(Icon);
